import {
  Factory,
  type ID,
  type Offset,
  ProjectActions,
} from '@octopus-do/octopus-project-core'
import { commitProjectRequest } from '@storeOld/actionCreators'
import {
  NotificationType,
  notificationActionCreators,
} from '@storeOld/reducers/notification'

export const clearError = () =>
  notificationActionCreators.setClearNotification({
    toastContainerId: 'main',
  })

export const showError = (text: string) =>
  notificationActionCreators.setCustomNotification({
    toastContainerId: 'main',
    type: 'coral',
    text,
  })

export const showDefaultError = () =>
  notificationActionCreators.setNotification({
    type: NotificationType.UPLOAD_ATTACHMENT_FILE_ERROR,
  })

export const createNewAttach = (
  id: ID,
  fileId: ID,
  offset: Offset,
  tabId: ID
) => {
  const attachment = Factory.attachment({
    id,
    offset,
    type: 'file',
    data: {
      id: fileId,
    },
  })

  const attachAction = ProjectActions.attachments.add({
    items: [attachment],
    index: 0,
    parents: [tabId],
  })

  return commitProjectRequest(attachAction)
}
